module.exports = __webpack_public_path__ + "img/Digi_entwurf_3.1.18737445.png";